import { LineItem } from '@medusajs/medusa';
import Image from 'next/image';
import Link from 'next/link';
import ReactGA from 'react-ga4';

import { useCartClient } from '@/components/Cart/hooks/useCartClient';
import { getVariantPrices } from '@/utils/getPrice';
import { formatPrice } from '@/utils/helpers/formatPrice';
import bin from 'public/icons/bin.svg';
import imagePlaceholder from 'public/images/product-placeholder.webp';

import styles from './styles.module.scss';

interface SideCartItemProps {
  item: LineItem;
}

const SideCartItem = ({ item }: SideCartItemProps) => {
  const { handleDeleteItem } = useCartClient();
  const productId = item.variant.product.handle;
  const { salePrice } = getVariantPrices(item.variant);

  const deleteItem = (item: LineItem) => {
    handleDeleteItem(item.id);

    ReactGA.event('remove_from_cart', {
      currency: 'PLN',
      value: (item.unit_price / 100) * item.quantity,
      items: [
        {
          item_id: item.variant.product_id,
          item_name: item.variant.product.title,
          quantity: item.quantity,
        },
      ],
    });
  };

  return (
    <div className={styles.container}>
      <Image
        width={70}
        height={70}
        alt={item.title}
        src={item.thumbnail ? item.thumbnail : imagePlaceholder}
      />
      <div className={styles.productInfo}>
        <Link className={styles.title} href={`/produkt/${productId}/`}>
          {item.title}
        </Link>
        {salePrice ? (
          <div>
            <p className={styles.pricing}>
              {item.quantity} x {formatPrice(item.unit_price)} PLN
            </p>
          </div>
        ) : (
          <p className={styles.pricing}>
            {item.quantity} x {formatPrice(item.unit_price)} PLN
          </p>
        )}
      </div>
      <Image
        className={styles.trashIcon}
        onClick={() => deleteItem(item)}
        width={18}
        height={18}
        alt={item.title}
        src={bin}
      />
    </div>
  );
};

export default SideCartItem;
